import React, { useState, useEffect } from 'react';
import { Box, Collapse, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NoRecord } from '../../../CommonComponent/NoRecord';
import NoDataImg from '../../../../../images/my-goal-bg.svg';
import { AddIconSvg, DeleteIcon, EditIcon, RightArrowIcon } from '../../../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../../../Common/OKRButton';
import {
	addLevelsData,
	deleteLevelsData,
	frameworkList,
	getLevelsByParentAndLevel,
	setRelaodSkillFramework,
} from '../../../../../action/adminSettings';
import { useDispatch, useSelector } from 'react-redux';
import { SkillLevelBox } from './SkillLevelBox';

export const FrameworkList: React.FC<any> = (props: any) => {
	const { handleEditFramework, handleDeleteFramework } = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const { reloadFrameworkListReload } = useSelector((state: any) => state.adminSettingReducer);
	const [frameworkListData, setFrameworkListData] = useState<any>(null);
	const [levelNewName, setLevelNewName] = useState<any>('');
	const [level1Data, setLevel1Data] = useState<any>({});

	useEffect(() => {
		getFrameworkList();
	}, []);

	useEffect(() => {
		if (reloadFrameworkListReload === true) {
			getFrameworkList();
			dispatch(setRelaodSkillFramework(false));
		}
	}, [reloadFrameworkListReload]);

	useEffect(() => {
		if (frameworkListData && frameworkListData.length > 0) {
			getLevelsByParentAndLevelData(
				frameworkListData[0].skillFrameworkId,
				{ id: frameworkListData[0].skillFrameworkId },
				1,
				-1
			);
		}
	}, [frameworkListData]);

	const getFrameworkList = async () => {
		try {
			const response: any = await dispatch(frameworkList());
			if (response) {
				if (response && response.data && response.data.status === 200) {
					let levelData: any = {};
					response.data.entityList.forEach((element: any, index: number) => {
						levelData[element.skillFrameworkId] = {};
					});
					setLevel1Data(levelData);
					setFrameworkListData(response.data.entityList || []);
				} else {
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	const getNextLevelData = async (currentIndex: number, skillId: any, parentData: any) => {
		const nextLevel = frameworkListData[skillId].levels[currentIndex + 1];
		if (nextLevel) {
			getLevelsByParentAndLevelData(
				frameworkListData[skillId].skillFrameworkId,
				parentData,
				nextLevel.levelId,
				currentIndex + 1
			);
		}
	};

	const getLevelsByParentAndLevelData = async (
		skillId: any,
		parentData: any,
		level = 1,
		replaceAfterIndex: number = 0
	) => {
		try {
			const response: any = await dispatch(
				getLevelsByParentAndLevel({
					parentId: parentData.id,
					level,
				})
			);
			if (response) {
				if (response && response.data && response.data.status === 200) {
					let lData = { ...level1Data };
					if (replaceAfterIndex !== -1) {
						frameworkListData.forEach((fm1: any, index1: number) => {
							if (fm1.skillFrameworkId === skillId) {
								fm1.levels.forEach((l1: any, index: number) => {
									if (index > replaceAfterIndex) {
										lData[skillId][l1.levelId] = {};
									}
								});
							}
						});
					}
					lData[skillId][level] = {
						parentData: level === 1 ? {} : parentData || {},
						levelData: response.data.entityList || [],
					};
					setLevel1Data(lData);
				} else {
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	const saveLevel1Attribute = async (skillId: number, parentData: any, levelId: number, name: string) => {
		try {
			const response: any = await dispatch(
				addLevelsData({
					id: 0,
					parentId: parentData.id,
					name: name,
					description: '',
					level: levelId,
				})
			);
			if (response) {
				if (response && response.data && response.data.status === 200) {
					getLevelsByParentAndLevelData(skillId, parentData, levelId, -1);
					setLevelNewName('');
				} else {
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	const handleRemoveLevel = async (
		currentIndex: number,
		skillId: any,
		parentData: any,
		levelDeleteId: number,
		levelId: number
	) => {
		try {
			const response: any = await dispatch(deleteLevelsData(levelDeleteId));
			if (response) {
				if (response && response.data && response.data.status === 200) {
					getLevelsByParentAndLevelData(skillId, parentData, levelId, currentIndex);
				} else {
				}
			}
		} catch (e) {
			console.error(e);
		}
	};
	return (
		<>
			{frameworkListData && frameworkListData.length > 0 ? (
				<Box className='skill-framework-list-area'>
					{frameworkListData.map((framework: any, index: number) => (
						<>
							<Box key={index} className='framework-details'>
								<Box className='framework-details-left'>
									<Typography variant='h2'>{framework.name}</Typography>
									<Typography variant='h6'>{framework.description}</Typography>
								</Box>
								<Box className='framework-details-right'>
									<OKRButton
										aria-label={t('Manage Framework')}
										handleClick={() => handleEditFramework(framework)}
										icon={<EditIcon />}
										className='editIcon'
										title={t('Edit Framework')}
									/>
									<OKRButton
										className='editIcon'
										icon={<DeleteIcon />}
										title={t('delete')}
										handleClick={() => handleDeleteFramework(framework?.skillFrameworkId)}
									/>
								</Box>
							</Box>

							<Box
								className={`manage-framework-level-area ${
									framework[`isLevel${index}Active`] ? 'framework-level-col-' : ''
								}`}
							>
								<Typography variant='h4'>Manage levels</Typography>
								<Box className='framework-level-listing-area'>
									<Box className='framework-level-list-card'>
										<Box className='framework-level-list-card-inner'>
											<Box className='framework-level-listing-head'>
												<Typography variant='h4'>{framework.levels[0].levelName}</Typography>
											</Box>
											<Box className='framework-level-listing-content'>
												<Box className='framework-level-listing-content-inner'>
													<Box className='framework-level-attribute-field'>
														<TextField
															id={`level-attribute`}
															className='level-attribute-field helperText-bottom'
															placeholder={`Add ${framework.levels[0].levelName}`}
															value={levelNewName}
															onChange={(e: any) => {
																setLevelNewName(e.target.value);
															}}
															InputLabelProps={{ shrink: true }}
															InputProps={{
																'aria-label': t('Add attributes', {}),
																disableUnderline: true,
																endAdornment: (
																	<InputAdornment position='end'>
																		<IconButton
																			edge='end'
																			aria-label={t('Add attribute')}
																			onClick={() => {
																				if (levelNewName.trim() !== '') {
																					saveLevel1Attribute(
																						framework.skillFrameworkId,
																						{ id: framework.skillFrameworkId },
																						framework.levels[0].levelId,
																						levelNewName
																					);
																				}
																			}}
																		>
																			<AddIconSvg />
																		</IconButton>
																	</InputAdornment>
																),
															}}
														/>
													</Box>
													{level1Data[framework.skillFrameworkId][framework.levels[0].levelId] &&
														level1Data[framework.skillFrameworkId][framework.levels[0].levelId].levelData &&
														level1Data[framework.skillFrameworkId][framework.levels[0].levelId].levelData.length > 0 &&
														level1Data[framework.skillFrameworkId][framework.levels[0].levelId].levelData.map(
															(level: any, levelIndex: number) => (
																<Box className='framework-level-attr-list'>
																	<Box className='framework-level-attr-row'>
																		<Box
																			className='framework-level-attr-col-1'
																			onClick={() => {
																				if (framework.levels.length > 1) {
																					getNextLevelData(0, index, level);
																				}
																			}}
																		>
																			<Typography>{level.name}</Typography>
																		</Box>
																		<Box className='framework-level-attr-col-2'>
																			<OKRButton
																				icon={<DeleteIcon />}
																				handleClick={() =>
																					handleRemoveLevel(
																						0,
																						framework.skillFrameworkId,
																						{ id: framework.skillFrameworkId },
																						level.id,
																						framework.levels[0].levelId
																					)
																				}
																				className='editIcon'
																				title={t('delete')}
																			/>
																		</Box>
																	</Box>
																</Box>
															)
														)}
												</Box>
											</Box>
										</Box>
									</Box>
									{framework.levels.map((level: any, idx: number) => (
										<>
											{' '}
											{idx !== 0 && (
												<SkillLevelBox
													skillFrameworkId={framework.skillFrameworkId}
													saveLevel1Attribute={saveLevel1Attribute}
													getNextLevelData={getNextLevelData}
													handleRemoveLevel={handleRemoveLevel}
													levelIndex={idx}
													index={index}
													parentLevel={level}
													levelData={
														level1Data[framework.skillFrameworkId] &&
														level1Data[framework.skillFrameworkId][level.levelId]
															? level1Data[framework.skillFrameworkId][level.levelId]
															: {}
													}
												></SkillLevelBox>
											)}
										</>
									))}
								</Box>
							</Box>

							<Box className='proficiency-list-area'>
								<Box className='proficiency-list-head'>
									<Typography variant='h4'>Proficiency</Typography>
								</Box>
								<Box className='proficiency-list-content'>
									{framework.proficiencyScales.map((proficiency: any, index: number) => (
										<Box className='proficiency-list-panel'>
											<Typography variant='h4' className='font-weight-normal'>
												{proficiency.name}
											</Typography>
											<Typography variant='subtitle2' className='subtitle3'>
												{proficiency.description}
											</Typography>
										</Box>
									))}
								</Box>
							</Box>
						</>
					))}
				</Box>
			) : (
				<NoRecord
					noRecordMessage={t('noSkillFrameworkCreatedYet')}
					subHead={t('clickPlusIconToAddFramework')}
					noDataImgWidth={'516'}
					noImg={NoDataImg}
					{...props}
				/>
			)}
		</>
	);
};
